import { Checkbox } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toggleCheckbox } from "../slices/preferencesSlice";

const data = [
  {
    value: "Profile",
  },
  {
    value: "Basic Info",
  },
  {
    value: "Educational Info",
  },
  {
    value: "Professional Info",
  },
  {
    value: "Docs Attachments",
  },
  {
    value: "Development Plan",
  },
  {
    value: "Certificates from M3",
  },
  {
    value: "Tier Benefits",
  },
  {
    value: "Assessment Results",
  },
  {
    value: "Achievement Portfolio",
  },
  {
    value: "Redeem Credits",
  },
  {
    value: "Surveys",
  },
  {
    value: "Privacy Management",
  },
  {
    value: "Delete Account",
  },
];

function Preferences() {
  const dispatch = useDispatch();
  const checkedItems = useSelector((state) => state.preferences.checkedItems);

  const handleCheckboxChange = (value) => {
    dispatch(toggleCheckbox({ value }));
  };

  return (
    <div>
      {data.map((items, i) => {
        return (
          <Checkbox
            key={i}
            className="text-white w-full "
            value={items.value}
            checked={checkedItems.includes(items.value)}
            onChange={(e) => handleCheckboxChange(e.target.value)}
          >
            {items.value}
          </Checkbox>
        );
      })}
    </div>
  );
}

export default Preferences;
